<div class="data-retention-no-data" dataRetentionNoData>
  @if (icon) {
    <capra-icon
      class="icon"
      data-test="data-retention-empty-state"
      width="72px"
      height="72px"
      icon="{{ icon }}"
    ></capra-icon>
  }
  <div class="content">
    @if (header) {
      <h3 class="header">{{ header }}</h3>
    }
    @if (subtext) {
      <p class="subtext">{{ subtext }}</p>
    }
  </div>
</div>
